import IndexPage from '@dex/bubl-dash/src/lib/pages/IndexPage';
import SportsActivitiesCreateEditForm from './Components/SportsActivitiesCreateEditForm';
import SportsActivitiesApi from './SportsActivitiesApi';

export default function (app, settings) {

    app.addRoute({
        name: settings.key + "New",
        zone: settings.zone,
        path: settings.key + "/create",
        caps: settings.createCaps,
        component: IndexPage,
        componentProps: {
            header: {
                getTitle: () => "Add New",
                getButtons: settings.indexButtons,
                getTabs: settings.indexTabs,
                getTabCounts: settings.indexTabCounts,
            },
            create: {
                form: SportsActivitiesCreateEditForm,
                getCreate: SportsActivitiesApi.create,
                defaults: {},
                successMessage: "Sports Activity Saved",
                successRouteName: settings.key + "View",
                idKey: settings.idKey
            }
        },
    });

}